import {useRef} from 'react'

import Style from './style'
import eraseIcon from 'shared/assets/erase.svg'
import downIcon from './asset/down.svg'
import upperIcon from './asset/upper.svg'
import checkIcon from './asset/check.svg'
import checkedIcon from './asset/checked.svg'
import useQuestionEvent from './model/useQuestionEvent'

import MainHeader from 'widget/MainHeader'

import useGetExamDetail from 'entity/exam/useGetExamDetail'
import usePostExam from 'entity/exam/usePostExam'

import CStyle from 'shared/style/commonStyle'
import ITStyle from 'shared/style/inputTableStyle'
import DefaultButton from 'shared/ui/DefaultButton'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'

const TryoutExamCreate = () => {
	const cutoffRef = useRef()

	const [getExamData] = useGetExamDetail()

	const [
		questionList,
		setProblem,
		createQuestionEvent,
		deleteQuestionEvent,
		upperQuestionEvent,
		downQuestionEvent,
		setChoice,
		createChoiceEvent,
		deleteChoiceEvent,
		upperChoiceEvent,
		downChoiceEvent,
		setAsnwerEvent,
		setPointEvent,
	] = useQuestionEvent(getExamData)

	const [postExam] = usePostExam(
		getExamData?.data?.pro_grade_flag,
		cutoffRef,
		questionList
	)

	const btnList = [
		{
			label: '생성',
			clickEvent: () => postExam(),
			deactive: false,
		},
	]

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} />

			<ITStyle.TableDiv>
				<ITStyle.TableElement>
					<h2>
						대상 프로 자격<span>*</span>
					</h2>
					<input
						value={convertProGradeAsName[getExamData?.data?.pro_grade_flag]}
						disabled
					/>
				</ITStyle.TableElement>
				<ITStyle.TableElement>
					<h2>
						커트라인 점수<span>*</span>
					</h2>
					<input
						defaultValue={getExamData?.data?.cutoff}
						placeholder='100이하의 숫자'
						ref={cutoffRef}
					/>
				</ITStyle.TableElement>
			</ITStyle.TableDiv>

			<Style.AreaDiv>
				<Style.AreaHeader>
					<h2>
						문제 목록<span>*</span>
					</h2>
					<DefaultButton small fitWidth clickEvent={createQuestionEvent}>
						문제 추가
					</DefaultButton>
				</Style.AreaHeader>
				<CStyle.GuideDiv>
					<p>문제의 개수와 각 문제 선다의 개수에는 제한이 없습니다.</p>
					<p>모든 문제 배점의 합은 100점이어야 합니다.</p>
				</CStyle.GuideDiv>

				{/* 문제 정보 입력 */}
				{questionList?.map((elem, index) => (
					<Style.QuestionDiv>
						<Style.QuestionTitle>
							<h2>Q{index + 1} </h2>
							<Style.QuestionInput
								placeholder='점수'
								value={elem?.point}
								onChange={(e) => setPointEvent(e, index)}
								$small
							/>
							<Style.QuestionInput
								placeholder='지문 입력'
								value={elem?.problem}
								onChange={(e) => setProblem(e, index)}
							/>
							<Style.ControlDiv>
								<button onClick={() => deleteQuestionEvent(index)}>
									<img src={eraseIcon} />
								</button>
								<button onClick={() => upperQuestionEvent(index)}>
									<img src={upperIcon} />
								</button>
								<button onClick={() => downQuestionEvent(index)}>
									<img src={downIcon} />
								</button>
							</Style.ControlDiv>
							<DefaultButton
								small
								fitWidth
								clickEvent={() => createChoiceEvent(index)}
							>
								선다 추가
							</DefaultButton>
						</Style.QuestionTitle>

						<Style.ChoiceDiv>
							{elem?.choice?.map((choiceElem, choiceIndex) => (
								<Style.Choice>
									<button onClick={() => setAsnwerEvent(index, choiceIndex)}>
										<img
											src={
												elem.answer === choiceIndex ? checkedIcon : checkIcon
											}
										/>
									</button>
									<input
										placeholder='선다 입력'
										value={choiceElem}
										onChange={(e) => setChoice(e, index, choiceIndex)}
									/>
									<Style.ControlDiv>
										<button
											onClick={() => deleteChoiceEvent(index, choiceIndex)}
										>
											<img src={eraseIcon} />
										</button>
										<button
											onClick={() => upperChoiceEvent(index, choiceIndex)}
										>
											<img src={upperIcon} />
										</button>
										<button onClick={() => downChoiceEvent(index, choiceIndex)}>
											<img src={downIcon} />
										</button>
									</Style.ControlDiv>
								</Style.Choice>
							))}
						</Style.ChoiceDiv>
					</Style.QuestionDiv>
				))}
			</Style.AreaDiv>
		</Style.Wrapper>
	)
}

export default TryoutExamCreate
